module.exports = __webpack_public_path__ + "assets/img/Lokyata-Landing-Page-+-Website.4c9ddf7b.jpg";